'use client';

import { c as _c } from "react/compiler-runtime";
import { type Options, parseAsInteger, parseAsString, useQueryState } from 'nuqs';
import useDebounce from '@/hooks/use-debounce';
import { env } from '@/shared/constants/env-variables';
interface UseFaqsSearchParamsResult {
  search: string;
  page: number;
  setSearch: (value: string | ((old: string) => string | null) | null, options?: Options | undefined) => Promise<URLSearchParams>;
  setPage: (value: number | ((old: number) => number | null) | null, options?: Options | undefined) => Promise<URLSearchParams>;
  debouncedSearch: string;
}
export function useFaqsSearchParams() {
  const $ = _c(10);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = parseAsString.withOptions({
      shallow: false
    }).withDefault("");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [search, setSearch] = useQueryState("search", t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = parseAsInteger.withOptions({
      shallow: false
    }).withDefault(1);
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [page, setPage] = useQueryState("page", t1);
  let t2;
  if ($[2] !== setPage) {
    t2 = {
      onDebounce: () => setPage(1)
    };
    $[2] = setPage;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const debouncedSearch = useDebounce(search, env.NEXT_PUBLIC_DEFAULT_DEBOUNCE_IN_MS, t2);
  let t3;
  if ($[4] !== debouncedSearch || $[5] !== page || $[6] !== search || $[7] !== setPage || $[8] !== setSearch) {
    t3 = {
      search,
      page,
      setSearch,
      setPage,
      debouncedSearch
    };
    $[4] = debouncedSearch;
    $[5] = page;
    $[6] = search;
    $[7] = setPage;
    $[8] = setSearch;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}